import { Box, Grid, ResponsiveContext, Text } from "grommet";
import { take } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { useNavigate, useParams } from "react-router-dom";
import { StatIcon } from "./StatIcon";
import { StatViewModel } from "./StatsStore";

export const StatRow = ({ stat, children }: { stat: StatViewModel; children: React.ReactElement }) => {
    let navigate = useNavigate();
    const size = React.useContext(ResponsiveContext);

    return (
        <Box background={"background"} pad="medium" hoverIndicator="background-back" onClick={() => navigate(`/stats/` + stat.id)}>
            <Grid columns={["1/4", "3/4"]}>
                <Box direction="row" gap="small">
                    {StatIcon(stat)}
                    <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
                        {stat.name}
                    </Text>
                </Box>
                <Box direction="row" fill>
                    <Text>{stat.description}</Text>
                </Box>
            </Grid>
        </Box>
    );
};
